import { useCallback, useState } from 'react';
import {
    PTS_VALIDATION_ERROR_MESSAGE,
    resolveEntriesForValidation,
    validatePtsDetailCalculations,
} from '../Utils/validatePtsDetailCalculations';

const useValidatePtsDetailCalculations = ({
    processedTimesheetId,
    processedTimesheetEntries = [],
    locations = [],
    onCalculationErrorsChange = () => {},
}) => {
    const [calculationErrors, setCalculationErrors] = useState([]);
    const [isValidatingCalculations, setIsValidatingCalculations] = useState(false);
    const [validationError, setValidationError] = useState(null);

    const handleCalculationErrors = useCallback(
        (errors) => {
            setCalculationErrors(errors);
            onCalculationErrorsChange(errors);
        },
        [onCalculationErrorsChange]
    );

    const validateCalculations = useCallback(
        async ({ shouldValidate = true } = {}) => {
            setValidationError(null);
            handleCalculationErrors([]);

            if (!shouldValidate) {
                return true;
            }

            setIsValidatingCalculations(true);

            try {
                const { entries, locations: resolvedLocations } = await resolveEntriesForValidation(
                    processedTimesheetId,
                    processedTimesheetEntries,
                    locations
                );
                const errors = validatePtsDetailCalculations(entries, resolvedLocations);

                if (errors.length > 0) {
                    handleCalculationErrors(errors);
                    return false;
                }

                return true;
            } catch (error) {
                console.error('PTS detail calculation validation failed:', error);
                setValidationError(PTS_VALIDATION_ERROR_MESSAGE);
                return false;
            } finally {
                setIsValidatingCalculations(false);
            }
        },
        [processedTimesheetId, processedTimesheetEntries, locations, handleCalculationErrors]
    );

    return {
        calculationErrors,
        isValidatingCalculations,
        validationError,
        validateCalculations,
    };
};

export default useValidatePtsDetailCalculations;
